import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Grid } from "@mui/material";
import ButtonPolicy from "../Permission/ButtonPolicy";
import { getSites } from "src/apis/complex";
import { useEffect } from "react";
import "./monitoring.css";
// Import the marker icon
import {
  redMarkerIcon,
  greenMarkerIcon,
  markerShadow,
} from "src/util/mapImages";
import { useState } from "react";
import { concat } from "lodash";

// Create a custom marker icon

const greenMarker = new L.Icon({
  iconUrl: greenMarkerIcon,
  iconRetinaUrl: greenMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [17, 25],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [15, 25],
});

const redMarker = new L.Icon({
  iconUrl: redMarkerIcon,
  iconRetinaUrl: redMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [17, 25],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [15, 25],
});

export default function MapWithDifferentLevels({
  headerTitle,
  locations,
  zoomLevel,
  center,
  clickHandleMarker,
  clickHandleButton
}) {
  const handleMarkerClick = (location) => {
    console.log(location);
    zoomLevel = 5;
  };

  return (
    <>
      <Grid container height={"100%"}>
        {/* Heading */}
        <Grid item md={12} lg={12} sm={12} xs={12}>
          <Grid container>
            <Grid item md={6} lg={6} sm={6} xs={6}>
              <h2>{headerTitle}</h2>
            </Grid>
            <Grid item md={6} lg={6} sm={6} xs={6}>
            {clickHandleButton && (
              <div className="siwtchButton">
                <ButtonPolicy  onClick={() => clickHandleButton()}type="button" >Switch Mode</ButtonPolicy>
              </div>)}
            </Grid>
          </Grid>
        </Grid>

        {/* Map */}
        <Grid item md={12} lg={12} sm={12} xs={12} height={"calc(100% - 72px)"}>
          <div className="map-container">
            <MapContainer
              center={center ? center : [41.9028, 12.4964]}
              zoom={zoomLevel}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              {/* Render the markers */}
              {locations && locations.length>0 &&  locations.map((location, index) => (
                (location.position[0] && location.position[1]) ?
                <Marker
                  key={index}
                  position={location.position}
                  icon={
                    location.alarm === true ? redMarker : greenMarker
                    //  greenMarker
                  }
                  /*icon={customMarkerIcon}*/
                  eventHandlers={{
                    mouseover: (e) => {
                      e.target.openPopup();
                    },
                    mouseout: (e) => {
                      e.target.closePopup();
                    },
                    click: (e) => {
                      clickHandleMarker(location);
                    },
                  }}
                >
                  <Popup>{location.name}</Popup>
                </Marker>
                :<></>
              ))}
            </MapContainer>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
